import { Component, OnInit } from '@angular/core';
import { ReposicionService } from './../../../reposicion.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-resumen-sucursales',
  templateUrl: './resumen-sucursales.component.html',
  styleUrls: ['./resumen-sucursales.component.css']
})
export class ResumenSucursalesComponent implements OnInit {
  sucursalesSeleccionadas: string[] = [];

  constructor(
    private reposicionService: ReposicionService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.reposicionService.sucursalesSeleccionadas$.subscribe((data) => {
      this.sucursalesSeleccionadas = data;
    });
  }
  volverDashboard() {
    this.router.navigate(['dashboard'], { relativeTo: this.route.parent });
  }
}
